/**
 * Vietnamese diacritic normalization (frontend).
 *
 * Shared by any component that needs accent-insensitive matching against
 * Vietnamese names — e.g. the Users/Employees list quick filters and the
 * Timesheets grid quick-jump search. Mirrors the backend equivalent in
 * `websites/backend/hr-system/workers/utils/normalizeVietnamese.ts` so
 * client-side and server-side matching stay in sync.
 *
 * @module utils/normalizeVietnamese
 */

/**
 * Strips Vietnamese diacritics/tone marks (and normalizes `đ`/`Đ` to `d`) and
 * lower-cases the result, so names can be matched regardless of accents —
 * e.g. searching "nguyen van a" finds "Nguyễn Văn A".
 *
 * @param input - The string to normalize (a name, or a search query).
 * @returns The lower-cased, accent-stripped string.
 */
export function normalizeVietnamese (input: string): string {
    return input
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[đĐ]/g, 'd')
        .toLowerCase();
}
